import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { PIOVerColumns } from '../gridcolumns';

const PIOVersions = ({ data }) => (
  <GridTable
    tag={`${TE.ID}pioversions${TE.TABLE}`}
    title="PIO Version(s)"
    exportTitle={`PIO Version(s)-${useGetPathProtocol()}-Versions`}
    columns={PIOVerColumns}
    user={GetUserFullName()}
    rows={data}
    filterable
    sortable
    enableToolbar
    recordPerPage={10}
    toPdf={false}
  />
);

export { PIOVersions };
